<div class="hse-loader-wrapper ng-hide">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-secondary" style="width: 6rem; height: 6rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
